/**
 * Created by neo on 23.03.21.
 */
import { makeAutoObservable } from 'mobx';

export enum DurationBefore {
  ONE_HOUR_BEFORE = 'PT1H',
  DAY_BEFORE = 'PT24H',
  HALF_HOUR_BEFORE = 'PT30M',
  MIN_15_BEFORE = 'PT15M',
  AT_EVENT = 'PT0S',
}

export const durationOrder = [
  DurationBefore.AT_EVENT,
  DurationBefore.HALF_HOUR_BEFORE,
  DurationBefore.ONE_HOUR_BEFORE,
  DurationBefore.DAY_BEFORE,
];

export type NotificationInterval = {
  title: string;
  message: string;
  durationBefore: DurationBefore;
  customData: Record<string, string>;
  sentAt?: string;
  requestId?: string;
};

export function createNotificationInterval(json?: Partial<NotificationInterval>): NotificationInterval {
  return makeAutoObservable({
    title: json?.title ?? '',
    message: json?.message ?? '',
    durationBefore: json?.durationBefore ?? DurationBefore.ONE_HOUR_BEFORE,
    customData: (json?.customData as any) ?? {},
    sentAt: json?.sentAt,
    requestId: json?.requestId,
  });
}
